import { useSourceUploadModalState } from '../hooks/useSourceUploadModalState';
import { SourceUploadModalEmptyState } from './SourceUploadModalEmptyState';
import { SourceUploadModalFilesSidebar } from './SourceUploadModalFilesSidebar';
import { SourceUploadModalFileSettings } from './SourceUploadModalFileSettings';

interface SourceUploadModalContentProps {
    state: ReturnType<typeof useSourceUploadModalState>;
    currentPlaybackTime: number;
    onTimeUpdate: (time: number) => void;
}

export function SourceUploadModalContent({
    state,
    currentPlaybackTime,
    onTimeUpdate,
}: SourceUploadModalContentProps) {
    const { files, activeFile, isMultipleMode } = state;

    if (files.length === 0) {
        return (
            <SourceUploadModalEmptyState
                onFilesSelected={state.handleFilesAdded}
            />
        );
    }

    if (!activeFile) return null;

    return (
        <div
            className={isMultipleMode ? 'flex gap-0 h-full' : 'overflow-y-auto'}
            style={isMultipleMode ? { minHeight: 0 } : undefined}
        >
            {isMultipleMode ? (
                <>
                    <SourceUploadModalFilesSidebar
                        files={files}
                        activeFileId={activeFile.id}
                        onFileSelect={state.handleFileSelect}
                        onFileDelete={state.handleFileDelete}
                    />
                    <div className="w-px bg-grey-500 flex-shrink-0" />
                    <div className="flex-1 flex flex-col gap-4 overflow-y-auto px-4 py-4 scrollbar-hide min-h-0">
                        <SourceUploadModalFileSettings
                            file={activeFile}
                            currentPlaybackTime={currentPlaybackTime}
                            onTimeUpdate={onTimeUpdate}
                            onDurationChange={state.handleVideoDuration}
                            onTrimChange={state.handleTrimChange}
                            onThumbnailsGenerated={
                                state.handleThumbnailsGenerated
                            }
                            onFileNameChange={state.handleFileNameChange}
                            onFaceRecognitionChange={
                                state.handleFaceRecognitionChange
                            }
                            onLicensePlateRecognitionChange={
                                state.handleLicensePlateRecognitionChange
                            }
                            onOpticalCharacterRecognitionChange={
                                state.handleOpticalCharacterRecognitionChange
                            }
                            onAnalysisFramesPerSecondChange={
                                state.handleAnalysisFramesPerSecondChange
                            }
                        />
                    </div>
                </>
            ) : (
                <div className="flex flex-col gap-4 px-4 py-4">
                    <SourceUploadModalFileSettings
                        file={activeFile}
                        currentPlaybackTime={currentPlaybackTime}
                        onTimeUpdate={onTimeUpdate}
                        onDurationChange={state.handleVideoDuration}
                        onTrimChange={state.handleTrimChange}
                        onThumbnailsGenerated={state.handleThumbnailsGenerated}
                        onFileNameChange={state.handleFileNameChange}
                        onFaceRecognitionChange={
                            state.handleFaceRecognitionChange
                        }
                        onLicensePlateRecognitionChange={
                            state.handleLicensePlateRecognitionChange
                        }
                        onOpticalCharacterRecognitionChange={
                            state.handleOpticalCharacterRecognitionChange
                        }
                        onAnalysisFramesPerSecondChange={
                            state.handleAnalysisFramesPerSecondChange
                        }
                    />
                </div>
            )}
        </div>
    );
}
